import { djangoHttpClient } from '~/src/clients/shippo/DjangoHttpClient';

const EMAIL_VERIFICATION_API_PREFIX = '/api/auth/email-verification';

export type EmailVerificationReason =
  | 'otc_code_expired'
  | 'otc_email_send_failed'
  | 'otc_email_verified'
  | 'otc_invalid_code'
  | 'otc_invalid_code_format'
  | 'otc_max_attempts_exceeded'
  | 'otc_missing_code'
  | 'success';

export type SendCodeResponse = {
  email: string;
  expires_in_seconds?: number;
  reason: EmailVerificationReason;
};

export type VerifyCodeResponse = {
  email: string;
  reason: EmailVerificationReason;
};

export type VerifyCodeRequest = {
  code: string;
};

export const sendCode = async (): Promise<SendCodeResponse> => {
  const res = await djangoHttpClient.post<SendCodeResponse>({
    url: `${EMAIL_VERIFICATION_API_PREFIX}/send-code/`,
  });
  return res.body as SendCodeResponse;
};

export const resendCode = async (): Promise<SendCodeResponse> => {
  const res = await djangoHttpClient.post<SendCodeResponse>({
    url: `${EMAIL_VERIFICATION_API_PREFIX}/resend-code/`,
  });
  return res.body as SendCodeResponse;
};

export const verifyCode = async (code: string): Promise<VerifyCodeResponse> => {
  const res = await djangoHttpClient.post<VerifyCodeResponse>({
    body: { code } satisfies VerifyCodeRequest,
    url: `${EMAIL_VERIFICATION_API_PREFIX}/verify-code/`,
  });
  return res.body as VerifyCodeResponse;
};
